import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { RequirementCheck } from "@shared/ui/RequirementCheck";

type Props = {
  password: string;
  isTooShortError: boolean;
  isInvalidStringError: boolean;
  layout?: "horizontal" | "vertical";
};

export function PasswordRequirements({
  password,
  isTooShortError,
  isInvalidStringError,
  layout,
}: Props) {
  const [isLongEnough, setIsLongEnough] = useState(false);

  const [hasSpecialChar, setHasSpecialChar] = useState(false);

  useEffect(() => {
    setIsLongEnough(password?.length >= 8);
  }, [password]);

  useEffect(() => {
    setHasSpecialChar(/[!@#$%^&*(),.?":{}|<>]/.test(password));
  }, [password]);

  return (
    <div
      className={twMerge(
        layout === "horizontal" &&
          "relative flex flex-col gap-1 transition-opacity duration-100 md:flex-row md:justify-end"
      )}
    >
      <div
        className={twMerge(
          "flex flex-col gap-2",
          layout === "horizontal" &&
            "relative flex w-full flex-col gap-4 md:w-2/3 md:ml-48 md:pl-6"
        )}
      >
        <RequirementCheck
          isMet={isLongEnough}
          message="Must be at least 8 characters long"
          captionClassName={twMerge(isTooShortError && "text-error")}
        />
        <RequirementCheck
          isMet={hasSpecialChar}
          message="Must contain a special character"
          captionClassName={twMerge(isInvalidStringError && "text-error")}
        />
      </div>
    </div>
  );
}

export default PasswordRequirements;
